import { Component } from '@angular/core';

@Component({
  selector: 'app-special-question-panel',
  templateUrl: './special-question-panel.component.html',
  styleUrls: ['./special-question-panel.component.scss'],
})
export class SpecialQuestionPanelComponent {
  now = new Date();
  startDate = new Date(2026, 1, 14, 0, 0, 0);
  stopDate = new Date(2026, 1, 24, 0, 0, 0);
}
